import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import { TEditProjectDetailsReduxParams } from '~types/feat/project';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import * as Styles from './_projectManagementProjectDetails.module.scss';
import ProjectManagementProjectDetailsForm from '../ProjectManagementProjectDetailsForm';

const ProjectManagementProjectDetailsModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.project.modals.projectDetailsModalIsOpen);
    const isEditing = useAppSelector(state => state.project.modals.isEditing);
    const getProjectDetailsError = useAppSelector(state => state.project.errors.getProjectDetails);
    const getProjectDetailsIsLoading = useAppSelector(state => state.project.loadings.getProjectDetails);
    const isLoading = useAppSelector(state => state.project.loadings.editProjectDetails);
    const editProjectDetailsError = useAppSelector(state => state.project.errors.editProjectDetails);
    const projectDetails = useAppSelector(state => state.project.projectDetails);

    const massagedprojectDetails = {
        ...projectDetails,
    };

    const setIsEditing = (isEditMode: boolean) => dispatch(combinedActions.projectSetProjectDetailsModalIsEditing(isEditMode));

    const handleModalOnClose = () => {
        setIsEditing(false);
        dispatch(combinedActions.projectResetEditProjectDetailsState());
        dispatch(combinedActions.projectSetProjectDetailsModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditProjectDetailsReduxParams) => isEditing && dispatch(combinedActions.projectEditProjectDetailsAttempt(data));

    return (
        <Modal
            title='Project Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {getProjectDetailsIsLoading
                ? (
                    <CustomClipLoader
                        blackBorder
                        className={Styles.loader}
                    />
                )
                : (
                    getProjectDetailsError
                        ? (
                            <Text
                                isError
                                label={getProjectDetailsError}
                            />
                        )
                        : (
                            <div className={Styles.subcontainer}>
                                <ProjectManagementProjectDetailsForm
                                    submitButtonLabel='Update'
                                    actionButtonIsLoading={isLoading}
                                    actionButtonClassName={Styles['form-action-button-disabled']}
                                    actionButtonIsDisabled={!isEditing}
                                    onSubmit={handleOnSubmit}
                                    inputIsDisabled={!isEditing}
                                    error={editProjectDetailsError}
                                    isEditing={isEditing}
                                    initialProjectDetails={massagedprojectDetails}
                                />
                            </div>
                        )
                )
            }
        </Modal>
    );
};

export default ProjectManagementProjectDetailsModal;
